export type WorkVisual = {
  image: string;
  background: string;
  imageFit?: 'cover' | 'contain';
  imagePosition?: string;
  imageScale?: number;
};

export const WORK_VISUALS: Record<string, WorkVisual> = {
  'golden-rule-dairy': {
    image: '/images/goldenruledairyhomepage.png',
    background:
      'radial-gradient(circle at top right, rgba(248, 201, 104, 0.18), transparent 42%), linear-gradient(135deg, rgba(243, 239, 232, 0.96), rgba(235, 227, 208, 0.94))',
    imageFit: 'contain',
    imagePosition: 'center center',
    imageScale: 1,
  },
  'roshi-health': {
    image: '/images/roshihealthhomepage.png',
    background:
      'radial-gradient(circle at top right, rgba(139, 224, 201, 0.2), transparent 42%), linear-gradient(135deg, rgba(243, 239, 232, 0.96), rgba(225, 240, 236, 0.94))',
    imageFit: 'contain',
    imagePosition: 'center center',
    imageScale: 1,
  },
};
